import { PortalBody, usePlateEditorState, usePlateId } from '@udecode/plate';
import cn from 'classnames';
import * as React from 'react';

import { usePopupPosition } from './use-popup-position';

export const BalloonToolbar = ({ children }: { children: JSX.Element }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const editor = usePlateEditorState(usePlateId() || undefined);
  const [styles, attributes, hidden] = usePopupPosition({ editor, element: ref }) as any;

  return (
    <PortalBody>
      <div
        ref={ref}
        style={{ ...styles.popper }}
        className={cn({
          'hidden h-0': hidden,
          'transition-all duration-200 z-2000': true,
          'transition-opacity duration-200': !hidden,
        })}
        {...attributes.popper}
      >
        {children}
      </div>
    </PortalBody>
  );
};
